import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        try {
            return localStorage.getItem("sadja-lang") || "en";
        } catch {
            return "en";
        }
    });

    const setLang = (l) => {
        try {
            localStorage.setItem("sadja-lang", l);
        } catch {
            /* ignore */
        }
        setLangState(l);
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);
